import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddAnioAcademico extends Component {
  static displayName = AddAnioAcademico.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      descripcion: '',
      errorMessage: '',
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWAnioAcademico');
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleDescripcionChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ descripcion: e.target.value });
  };

  isOkToSave() {
    return this.state.descripcion.trim().length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) return;
    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'El campo Año es obligatorio' });
      return;
    }
    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/anioAcademico/', {
      method: 'POST',
      body: JSON.stringify({ AnioAcademicoDescripcion: this.state.descripcion.trim() }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el año académico. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-anios" />;
    }

    const { loading, descripcion, errorMessage } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-anios">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nuevo Año Académico</h1>
        <p className="md-form-page__subtitle">
          Ingrese la descripción del año académico que desea registrar.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando año académico, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="anio-descripcion">
                Año Académico
              </label>
              <input
                id="anio-descripcion"
                className="md-form-page__input"
                type="text"
                value={descripcion}
                placeholder="Ingrese año"
                onChange={this.handleDescripcionChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
